<template>
  <div>
    <!-- {{ question.options }} -->
    <!-- selected: {{ selected }} -->
    <v-list-item
      v-for="(option, i) in question.options"
      :key="`list_${option}_${i}`"
      class="group-item-list"
      @click="onItemClick(option, question)"
      :value="option.value"
      :disabled="isReadOnly"
    >
      <template v-slot:default="{ active }">
        <!-- {{ option }} -->
        <v-list-item-content class="font-weight-medium">
          <v-layout>
            <v-row align="center">
              <v-col cols="1">
                <v-row no-gutters justify="start">
                  <v-checkbox
                    :id="`c_${option}_${i}`"
                    :input-value="active"
                    hide-details
                    dense
                    class="pa-0 ma-0 pl-1"
                    :disabled="isReadOnly"
                  ></v-checkbox>
                  <!-- <v-checkbox
                    :id="`c_${option}_${i}`"
                    v-model="selected"
                    :value="option"
                    hide-details
                    dense
                    class="pa-0 ma-0 pl-1"
                  ></v-checkbox> -->
                </v-row>
              </v-col>
              <v-col cols="8" class="px-0">
                <v-row no-gutters justify="start"
                  ><span class="expire-label">{{ option.text }}</span></v-row
                >
              </v-col>
            </v-row>
          </v-layout>
        </v-list-item-content>
      </template>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: "CheckBoxChoice",
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    answer: {
      type: [Number, String, Array, Object],
    },
    isReadOnly: { type: Boolean, default: false },
    // selected: {
    //   type: [Array, Object],
    //   default: () => [],
    // },
  },
  computed: {
    selected() {
      return this.question.selectedAnswer || [];
    },
  },
  data() {
    return {
      // selected: [],
    };
  },
  methods: {
    onItemClick,
  },
};

function onItemClick(item, question) {
  //   item.voteCount++;
  //   this.selectedItem = item;
  //   question.selectedAnswer = item;
  // // if (this.selected === null) {
  // //   this.selected = [];
  // // }
  // const indexOfObject = this.selected.findIndex((object) => {
  //   return (
  //     String(object.text).toLowerCase() === String(item.text).toLowerCase()
  //   );
  // });
  // if (indexOfObject > -1) {
  //   this.selected.splice(indexOfObject, 1);
  // } else {
  //   this.selected.push(item);
  // }
  // this.$emit("update", this.selected);
}
// item.isSelected = !item.isSelected;
</script>

<style scoped >
.border {
  border: 1px solid gray;
}
.group-item-list {
  margin-top: 2px;
  margin-bottom: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}
.expire-label {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}

.vote-label {
  font-size: 0.688rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
  color: darkblue;
}
.v-list-item-group .v-list-item--active {
  color: #3f51b5 !important;
  caret-color: #3f51b5 !important;
}
</style>